import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  Grid,
  Alert,
  CircularProgress,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Card,
  CardContent,
} from '@mui/material';
import { AccountBalance, Payment } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '@/store';
import { withdraw } from '@/store/slices/userSlice';
import { useNavigate } from 'react-router-dom';

const Deposit: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { creditCards } = useSelector((state: RootState) => state.user);
  const { isLoading, error } = useSelector((state: RootState) => state.user);
  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Deposits Unavailable
        </Typography>
        <Alert severity="info">
          Deposits are not available. TRANSACTIONS FROM THIS DASHBOARD ARE VIRTUAL ONLY. Please contact support for more information.
        </Alert>
      </Paper>
    </Container>
  );
};

export default Deposit;
